export default "__VITE_ASSET__DfylaJbB__"